module.exports = __webpack_public_path__ + "static/media/televox-housecalls-pro-logo.795dfb10.svg";